// config/AppVersion.js
export const appVersion = 'v1.0.84'; // Versão do aplicativo - Corrigido layout e footer em modo alto contraste
